import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT, SV_RADIUS_MD} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        "& .MuiInputBase-root": {
            borderRadius: SV_RADIUS_MD,
        },
        '.lightTheme & .MuiOutlinedInput-notchedOutline': {
            borderColor: SV_LIGHT.lineStrong,
        },
        '.lightTheme & .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: SV_LIGHT.text2,
        },
        '.lightTheme & .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: SV_LIGHT.accent,
            borderWidth: '1px',
        },
        '.darkTheme & .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: SV_DARK.accent,
            borderWidth: '1px',
        },
    },
}
